export const scrollPercent = () => {
  const scrollTop = window.scrollY
  const docHeight = document.body.offsetHeight
  const winHeight = window.innerHeight
  const percent = scrollTop / (docHeight - winHeight)
  return Math.round(percent * 100)
}
